'use strict';

customerZone.run(['$rootScope', 'Session', 'VerificationService', function($rootScope, Session, service){
    $rootScope.$on(Session.SUBSCRIPTION_CHANGED_EVENT, function(){
        service.checkVerificationStateExpiry();
    });
}]);
